'use client';

import { MovieClubIcon } from '@/components/icons/movie-club-icon';
import { Anchor } from '@/components/ui/anchor';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { useDataAnalytics } from '@/hooks/analytics/analytics';
import { MovieRewardsInfo } from '@cinemark/content-api-client';
import { Benefit } from './benefit';
import { getBenefits, shouldShowSection } from './benefit-helpers';

type MovieRewardsInfoImageHeaderProps = {
  hideCTA?: boolean;
  movieRewardsInfo: MovieRewardsInfo;
};

export const MovieClubSection = ({ hideCTA, movieRewardsInfo }: MovieRewardsInfoImageHeaderProps): React.JSX.Element | null => {
  const { trackClick } = useDataAnalytics();

  const benefits = getBenefits(movieRewardsInfo, 'movie-club');
  const hasCTA = !hideCTA && !!movieRewardsInfo.movieClubNonSubscriberButtonCTA;

  if (!shouldShowSection(movieRewardsInfo.movieClubNonSubscriberHeader, benefits.length, hasCTA)) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-md py-lg px-ms bg-[var(--color-movie-club-info)] text-white rounded-sm">
      <MovieClubIcon />

      {movieRewardsInfo.movieClubNonSubscriberHeader && <h2 data-test="movie-club-header">{movieRewardsInfo.movieClubNonSubscriberHeader}</h2>}

      {!!benefits.length &&
        <div className="flex items-center md:w-full">
          <div className="flex flex-col gap-sm w-full md:flex-row md:justify-between">
            {benefits.map((benefit, index) =>
              <Benefit key={index}
                benefitIndex={index + 1}
                header={benefit.header}
                image={benefit.image}
                imageSmall={benefit.imageSmall}
                text={benefit.text}
                type="movie-club"
              />
            )}
          </div>
        </div>
      }

      {hasCTA &&
        <Anchor className="justify-self-center"
          data-test="link-movie-club-cta"
          href="/movieclub"
          size="lg"
          onClick={() => trackClick({
            linkCategory: AnalyticsPageCategories.MOVIE_REWARDS,
            linkName: 'Movie Club CTA',
          })}
        >
          {movieRewardsInfo.movieClubNonSubscriberButtonCTA}
        </Anchor>
      }
    </div>
  );
};
